import "./SiteConfigurationGroupScheduleInfo.html";
import "./SiteConfigurationGroupScheduleInfo.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

// tslint:disable-next-line:max-line-length
import SiteConfigurationGroupScheduleInfoComponentController from "./SiteConfigurationGroupScheduleInfoComponentController";

export class SiteConfigurationGroupScheduleInfoComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            schedules: "<",
        };
        this.controller = SiteConfigurationGroupScheduleInfoComponentController;
        this.templateUrl =
            "/App/Components/Site/ConfigurationGroups/Info/Schedule/SiteConfigurationGroupScheduleInfo.html";
    }
}

module("mmManagePortal").component(
    "irSiteConfigurationGroupScheduleInfo",
    new SiteConfigurationGroupScheduleInfoComponent(),
);
